module.exports = __webpack_public_path__ + "static/media/hdc-63-connect.bfb367bc.png";